import React from 'react';
import  {jQuery, Component} from './Helpers';
import Content from './Content';
import Context from './Context';
import './App.scss';
import stickybits from 'stickybits';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 4,
      demographic: new Set(['white', 'hispanic']),
      indicator: 'hs-graduate',
      width: window.innerWidth
    };
    this.fetch();
  }

  async fetch() {
    const response = await fetch(`https://assets.pewresearch.org/interactives/socialtrends/2020/race-disparity/data.json`);
    const data = await response.json();
    this.setState({data: data});  ``
  }


  resize = (e) => {
    this.setState({width: window.innerWidth});
  }

  set_indicator = (e,d) => {
    this.setState({ indicator: d.name});
  }

  set_demographic = (e,d) => {
	if (this.state.demographic.size == 2 || ((this.state.demographic.has('asian') || d.name == 'asian') && ~['median-wealth', 'life-expectancy'].indexOf(this.state.indicator))) {
		this.setState(({ demographic }) => ({
        demographic: new Set(demographic.clear())
      }));
	}
    if (!this.state.demographic.has(d.name)) {
      this.setState(({ demographic }) => ({
        demographic: new Set(demographic).add(d.name)
      }));
    } else {
      this.setState(({ demographic }) => {
        const newDemographic = new Set(demographic);
        newDemographic.delete(d.name);

        return {
         demographic: newDemographic
        };
      });
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    if (typeof window.CSS === 'undefined' || !window.CSS.supports('(position : sticky) or (position: -webkit-sticky)')) {
      stickybits('.graphic.sticky',{stickyBitStickyOffset: window.innerHeight/2});
    }

  }

  render()  {
    return (
      <Context.Provider value={{...this.state, set_indicator: this.set_indicator, set_demographic: this.set_demographic}}>
        <Content />
      </Context.Provider>
    );
  }
}

export default App;
